// additional JS
$('.all-inputs-sizes input[type="radio"]').on('change', function () {
  // Remove 'active' class from all labels
  $('.all-inputs-sizes label').removeClass('activeSize');

  // Add 'active' class to the selected label
  $('label[for="' + this.id + '"]').addClass('activeSize');

  // Log the selected value
  console.log('Selected size:', this.value);
});

$('.subscription-option').on('click', function() {
    // Remove 'selected' class from all
    $('.subscription-option').removeClass('selected');
    
    // Add 'selected' class to the clicked one
    $(this).addClass('selected');

    // Optional: log selected subscription value
    console.log('Selected plan:', $(this).data('subscription-value'));
  });

$('.product-list .product-list-img').on('click', function() {
    $('.product-list .product-list-img').removeClass('selected-product');
    $(this).addClass('selected-product');
  });


$('.free-product .product-list-img').on('click', function() {
    $('.free-product .product-list-img').removeClass('selected-product');
    $(this).addClass('selected-product');
  });



// qty code
const decreaseBtn = document.getElementById('qty-decrease');
const increaseBtn = document.getElementById('qty-increase');
const qtyInput = document.getElementById('qty-input');

 

 

// If you have a 'change' or 'input' event on qtyInput that updates URL, it'll now trigger once per click
qtyInput.addEventListener('change', () => {
  // your logic to update URLs based on new qty
  refreshSelectionsAndURLs();
});

//  end - qty code

// change product title

function updateDesignAndImage() {
    const selectedInput = $('input[name="product_option"]:checked');
    const selectedValue = selectedInput.val();
    const selectedImgSrc = selectedInput.siblings('img').attr('src');

    // Update the design name
    $('#design-name').text(selectedValue);

    // Update the big image src
    $('.big-image img').attr('src', selectedImgSrc);
  }

  // Initial update on page load
  updateDesignAndImage();

  // Update on change
  $('input[name="product_option"]').on('change', updateDesignAndImage);
// end product title code

// cart btn code

$(document).ready(function () {
  // Keep product & free product data
  let productData = {};
  let freeProductData = {};

  function updateSelectedProduct() {
    const selectedProduct = $('.product-list input.product-radio:checked');
    productData = {
      name: selectedProduct.val(),
      size_small: selectedProduct.data('size-small'),
      size_medium: selectedProduct.data('size-medium'),
      size_large: selectedProduct.data('size-large')
    };
  }

  function updateSelectedFreeProduct() {
    const selectedFreeProduct = $('.free-product input.product-radio:checked');
    freeProductData = {
      name: selectedFreeProduct.val(),
      size_small: selectedFreeProduct.data('size-small'),
      size_medium: selectedFreeProduct.data('size-medium'),
      size_large: selectedFreeProduct.data('size-large')
    };
  }

  function getSelectedSizeValue() {
    return $('.all-inputs-sizes input[name="option2"]:checked').val();
  }

  function getSelectedQuantity() {
    let qty = parseInt($('#qty-input').val(), 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    return qty;
  }

  function getSelectedSubscription() {
    const selectedSub = $('.subscription-option.selected');
    return {
      frequency: selectedSub.data('frequency'),
      subscriptionValue: selectedSub.data('subscription-value')
    };
  }

  function generateURLs() {
    const selectedSize = getSelectedSizeValue().toLowerCase();
    const quantity = getSelectedQuantity();
    const subscription = getSelectedSubscription();

    const productSizeID = productData[`size_${selectedSize}`];
    const freeProductSizeID = freeProductData[`size_${selectedSize}`];

    const cartURL = `https://waggyy.com/cart/add?` +
      `items[0][id]=${productSizeID}&` +
      `items[0][quantity]=${quantity}&` +
      `items[0][selling_plan]=${subscription.subscriptionValue}&` +
      `items[1][id]=${freeProductSizeID}&` +
      `items[1][quantity]=1`;

    // Properly encode return_to URL for nested redirect
    const checkoutURL = `https://waggyy.com/cart/clear?return_to=` +
      encodeURIComponent(`/cart/add?items[0][id]=${productSizeID}&items[0][quantity]=${quantity}&items[0][selling_plan]=${subscription.subscriptionValue}&items[1][id]=${freeProductSizeID}&items[1][quantity]=1&return_to=/checkout`);

    console.log('Generated Cart URL:', cartURL);
    console.log('Generated Checkout URL:', checkoutURL);

    // Update buttons href
    $('#cart-url-output').attr('href', cartURL);
    $('#checkout-url-output').attr('href', checkoutURL);

    return {
      cartURL,
      checkoutURL
    };
  }

  function refreshSelectionsAndURLs() {
    updateSelectedProduct();
    updateSelectedFreeProduct();
    generateURLs();
  }

  // Event bindings
  $('.product-list input.product-radio').on('change', refreshSelectionsAndURLs);
  $('.free-product input.product-radio').on('change', refreshSelectionsAndURLs);
  $('.all-inputs-sizes input[name="option2"]').on('change', refreshSelectionsAndURLs);
  $('.subscription-option').on('click', function () {
    $('.subscription-option').removeClass('selected');
    $(this).addClass('selected');
    refreshSelectionsAndURLs();
  });

  // Quantity controls — replace with your quantity selector HTML & IDs
  $('#qty-increase').on('click', function () {
    let qty = getSelectedQuantity();
    $('#qty-input').val(qty + 1);
    refreshSelectionsAndURLs();
  });

  $('#qty-decrease').on('click', function () {
    let qty = getSelectedQuantity();
    if (qty > 1) {
      $('#qty-input').val(qty - 1);
      refreshSelectionsAndURLs();
    }
  });

  $('#qty-input').on('input change', function () {
    refreshSelectionsAndURLs();
  });

  // Initial call
  refreshSelectionsAndURLs();
});


// end cart





 // calculator js

document.querySelectorAll('.method-button').forEach(button => {
    button.addEventListener('click', function () {
      document.querySelectorAll('.method-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
    });
  });
 
    const commonBreeds = {
      'Beagle': 'Small',
      'Cavalier King Charles': 'Small',
      'French Bulldog': 'Small',
      'Jack Russell': 'Small',
      'Miniature Poodle': 'Small',
      'Pug': 'Small',
      'Shih Tzu': 'Small',
      'Small Bulldog': 'Small',
      'Small Great Dane': 'Small',
      'Small Rottweiler': 'Small',
      'Australian Shepherd': 'Medium',
      'Border Collie': 'Medium',
      'Husky': 'Medium',
      'Standard Poodle': 'Medium',
      'Vizsla': 'Medium',
      'German Shepherd': 'Large',
      'Golden Retriever': 'Large',
      'Golden Doodle': 'Large',
      'Doberman': 'Large',
      'Large Bulldog': 'Large',
      'Labrador Retriever': 'Large'
    };

    const breedSelect = document.getElementById('breed-select');
    const weightInput = document.getElementById('weight-input');
    const neckInput = document.getElementById('neck-input');
    const resultBox = document.getElementById('result');
    const sizeText = document.getElementById('size-text');
    const sizeDesc = document.getElementById('size-desc');

    function getSizeByWeight(weight) {
      const w = parseFloat(weight);
      if (w <= 25) return 'Small';
      if (w <= 55) return 'Medium';
      return 'Large';
    }

    function getSizeByNeck(neck) {
      const n = parseFloat(neck);
      if (n <= 16) return 'Small';
      if (n <= 21) return 'Medium';
      return 'Large';
    }

    function showResult(size) {
      const descriptions = {
        Small: 'Perfect for necks 12-16"',
        Medium: 'Perfect for necks 16-21"',
        Large: 'Perfect for necks 21-25"'
      };
      sizeText.textContent = size;
      sizeDesc.textContent = descriptions[size];
      resultBox.classList.remove('hidden');
    }

    function resetInputs() {
      breedSelect.classList.add('hidden');
      weightInput.classList.add('hidden');
      neckInput.classList.add('hidden');
      resultBox.classList.add('hidden');
    }

    // Populate breed dropdown
    Object.keys(commonBreeds).forEach(breed => {
      const option = document.createElement('option');
      option.value = breed;
      option.textContent = breed;
      breedSelect.appendChild(option);
    });

    // Event listeners for method buttons
    document.getElementById('method-breed').addEventListener('click', () => {
      resetInputs();
      breedSelect.classList.remove('hidden');
    });

    document.getElementById('method-weight').addEventListener('click', () => {
      resetInputs();
      weightInput.classList.remove('hidden');
    });

    document.getElementById('method-neck').addEventListener('click', () => {
      resetInputs();
      neckInput.classList.remove('hidden');
    });

    breedSelect.addEventListener('change', (e) => {
      const size = commonBreeds[e.target.value];
      if (size) showResult(size);
    });

    weightInput.addEventListener('input', (e) => {
      const size = getSizeByWeight(e.target.value);
      showResult(size);
    });

    neckInput.addEventListener('input', (e) => {
      const size = getSizeByNeck(e.target.value);
      showResult(size);
    });